export default "__VITE_ASSET__C_FChM_7__"